import React from 'react';
import { LogoRex, LogoDT, Card } from '@/components/ui';
import { Text } from '@/components/ui/text';
import { colors } from '@/assets/styles/colors';
import { getFiscalizadorDTUrl } from '@/api';


interface LoginLayoutProps {
  children: React.ReactNode;
  title?: string;
  description?: string;
}

export const LoginLayout: React.FC<LoginLayoutProps> = ({ 
  children, 
  title = '¡Bienvenido a Rex asistencia!',
  description,
}) => (
  <div 
    className="relative w-full min-h-screen flex justify-center"
    style={{ backgroundColor: colors.grays.neutralFF }}
  >
    <div
      className="fixed top-0 left-0 w-full h-[300px] rounded-b-[15px] z-0"
      style={{
        background: `linear-gradient(${colors.primary.dark}, ${colors.primary.main})`,
      }}
    />

    <a
      href={getFiscalizadorDTUrl()}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed top-2 right-4 z-20 flex items-center gap-2 text-white text-sm hover:opacity-80 transition-opacity"
    >
      <LogoDT />
      <Text variant="body-regular" className="text-sm" color="white">
        Ir a Fiscalización D.T.
      </Text>
    </a>

    <div className="relative z-10 w-full max-w-sm mt-[100px]  min-w-[428px]">
      <Card 
        elevation={3}
        borderRadius="16px"
        padding="32px"
        className="mx-auto"
      >
        <div className="text-center mb-8">
          <LogoRex />
          <div className="mt-6">
            <Text variant="body-title-medium" color={colors.primary.main}>
              {title}
            </Text>
          </div>
        </div>
          
        {description && (
          <div className="text-left">
            <Text variant="subheader-regular">
              {description}
            </Text>
          </div>
        )}
          
        {children}
      </Card>

      <div className="mt-8">
        <Text variant="subheader-medium" lineHeight="20px" className="text-center" color={colors.primary.dash}>
          Versión 1.1.1.2 Servicio 7/24
        </Text>
      </div>
    </div>
  </div>
);
